'use client';

import React from 'react';
import AppImage from '@/components/ui/AppImage';
import Link from 'next/link';

const HeroSection = () => {
  const handleGuideDownload = () => {
    // Extract file ID from Google Drive URL
    const fileId = '14ZoahN14HMSCHgwPjvKucshNWTXbUXcC';
    
    // Create direct download link
    const downloadUrl = `https://drive.google.com/uc?export=download&id=${fileId}`;
    
    // Open in new window to trigger download
    const downloadWindow = window.open(downloadUrl, '_blank');
    
    // Fallback: If popup blocked, use direct navigation
    if (!downloadWindow) {
      window.location.href = downloadUrl;
    }
  };

  return (
    <section className="relative min-h-[600px] flex items-center bg-gradient-to-br from-primary-900 to-primary-700 text-white overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.4"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")' }}></div>
      </div>

      <div className="container mx-auto px-4 py-16 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <div className="inline-block bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-medium">
              🇲🇦 Votre partenaire de confiance depuis 2018
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
              Réalisez Votre Rêve Marocain
            </h1>
            
            <p className="text-xl text-white/90 leading-relaxed">
              De la planification à l'installation, nous vous accompagnons à chaque étape de votre nouvelle vie au Maroc. Expertise locale, service personnalisé, résultats garantis.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={handleGuideDownload}
                className="bg-white text-primary-700 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-all transform hover:scale-105 shadow-lg text-center inline-flex items-center justify-center gap-2"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                Télécharger Notre Guide
              </button>
              <Link href="/services">
                <button className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white/10 transition-all">
                  Découvrir Nos Services
                </button>
              </Link>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-white/20">
              <div className="text-center">
                <div className="text-3xl font-bold text-white">+500</div>
                <div className="text-sm text-white/80">Familles accompagnées</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-white">98%</div>
                <div className="text-sm text-white/80">Satisfaction</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-white">2018</div>
                <div className="text-sm text-white/80">Depuis</div>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="order-first md:order-none">
            <AppImage
              src="https://images.unsplash.com/photo-1558255703-f068cda9e21d"
              alt="Panoramic view of Marrakech medina with traditional red buildings and Atlas Mountains in background at golden hour"
              className="w-full h-full object-cover rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;